export default "__VITE_ASSET__ab084f82__"